const Text = {
    baseStyle: {
        cursor: "default"
    },
    layer: {}
}

export default Text;